import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from "strongly-typed-events";
import { ControladorBase } from '@/components/a-interfaz/a-controlador';
import { isNumber, isString } from 'util';
import { Utiles } from '@/__env/pluggins/event-bus';
import router from '@/__env/router.index';
import { Articulo } from '@/__env/lib/Articulos';
import { Guid, Wait, Random } from '@/__env/ext';
import { publicDecrypt } from 'crypto';

export class ControladorInterfaz extends ControladorBase
{
    constructor()
    {
        super();
        this.Vista.Titulo = 'Alta de imágenes';
        this.Vista.Opciones.push(
            { Tipo: 'opcion', Icono: 'view-list', Modo: 'resumen', Titulo: 'Resumen' },
            { Tipo: 'opcion', Icono: 'package', Modo: 'imagenes', Titulo: 'Imagenes' },
        );
    }

    public Imagenes: ImagenMasivo[] = [];
    async Iniciar()
    {
        this.Vista.Estado = 'iniciado';

    }


    async Recargar()
    {

    }

}

export class ImagenMasivo
{
    constructor()
    {
        this.Id = Guid.create().toString();
    }

    public Id: string = '';
    public Codigo: string = '';
    public Imagen: File = null;
    public get Url()
    {
        return URL.createObjectURL( this.Imagen );
    }
    public Nombre: string = '';


    public Error: boolean = false;
    public Completado: boolean = false;
    public Subiendo: boolean = false;
    public async Subir(): Promise<boolean>
    {
        this.Subiendo = true;
        await Wait( 1000 );
        let ar = await Articulo.SubirImagen( this.Codigo, this.Imagen);
        if ( ar )
        {
            this.Completado = true;
    
        } else
        {
            this.Error = true;
        }
        this.Subiendo = false;
        return this.Completado;
    }
}

export const Controlador = new ControladorInterfaz();


